import { TargetsTabs } from "@shared/features/bots/BotForm/common/types";
import { useState } from "react";
import { BacktestingRunType } from "@shared/types";

interface UseTargetsStatisticProps {
  data?: BacktestingRunType;
}

const useTargetsStatistic = ({ data }: UseTargetsStatisticProps) => {
  const [tab, setTab] = useState(TargetsTabs.ENTRIES);
  const [expanded, setExpanded] = useState({
    [TargetsTabs.ENTRIES]: false,
    [TargetsTabs.TAKE_PROFITS]: false,
  });
  const maxTargetsToDisplay = 3;

  const onExpandCollapseClick = () => {
    setExpanded((prev) => {
      return { ...prev, [tab]: !prev[tab] };
    });
  };

  const getTabContent = (tab: TargetsTabs) => {
    const targetToTrades = Object.entries(data?.[TABS_TO_KEY[tab]] || {});
    let mainContent = targetToTrades;
    let collapsedContent;
    if (targetToTrades.length > maxTargetsToDisplay) {
      mainContent = mainContent.slice(0, maxTargetsToDisplay);
      collapsedContent = targetToTrades.slice(
        maxTargetsToDisplay,
        targetToTrades.length
      );
    }

    return { mainContent, collapsedContent };
  };

  return { tab, setTab, expanded, onExpandCollapseClick, getTabContent };
};

export default useTargetsStatistic;

export const TABS_TO_KEY: Record<
  TargetsTabs,
  "filled_entry_target_to_counter" | "filled_take_profit_target_to_counter"
> = {
  [TargetsTabs.ENTRIES]: "filled_entry_target_to_counter",
  [TargetsTabs.TAKE_PROFITS]: "filled_take_profit_target_to_counter",
};
